import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAppFilters } from "../state/filters";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export default function FilterBar() {
  const { rep, setRep, source, setSource } = useAppFilters();
  const [reps, setReps] = useState([]);
  const [sources, setSources] = useState([]);

  useEffect(() => {
    let dead = false;
    (async () => {
      try {
        const [r, s] = await Promise.all([
          api.get("/reps"),
          api.get("/sources"),
        ]);
        if (dead) return;
        setReps(r.data.items || []);
        setSources(s.data.items || []);
      } catch { /* ignore */ }
    })();
    return () => { dead = true; };
  }, []);

  return (
    <div className="hidden lg:flex items-center gap-2">
      <Select value={rep || "__all__"} onValueChange={(v) => setRep(v === "__all__" ? null : v)}>
        <SelectTrigger className="h-8 w-[200px] text-xs" data-testid="global-filter-rep">
          <SelectValue placeholder="All reps" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="__all__">All reps ({reps.length})</SelectItem>
          {reps.map((r) => (
            <SelectItem key={r.name} value={r.name}>
              <span className="flex items-center gap-2">
                <span>{r.name}</span>
                {r.aliases && r.aliases.length > 0 && (
                  <span
                    className="text-[10px] text-muted-foreground"
                    title={`Includes: ${r.aliases.join(", ")}`}
                  >
                    +{r.aliases.length}
                  </span>
                )}
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={source || "__all__"} onValueChange={(v) => setSource(v === "__all__" ? null : v)}>
        <SelectTrigger className="h-8 w-[160px] text-xs" data-testid="global-filter-source">
          <SelectValue placeholder="All sources" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="__all__">All sources</SelectItem>
          {sources.map((s) => (<SelectItem key={s} value={s}>{s}</SelectItem>))}
        </SelectContent>
      </Select>
    </div>
  );
}
